// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BKyR","questions":"styles_questions__2tgZE","footer":"styles_footer__2A8-0"};